module.exports = __webpack_public_path__ + "static/media/Dosis-VariableFont_wght.4cf98699.ttf";